module.exports = __webpack_public_path__ + "media/photos/term-bg-5-b969e5d5.jpg";